<div class="maintenance-tab">
  <div class="row">
    <!-- Left Column -->
    <div class="col-md-6">
      <div class="form-group">
        <label class="col-md-6 control-label" for="trailerStatus">TRAILER STATUS</label>
        <div class="col-md-6 inputSpace">
          <span [ngClass]="getStatusPillClass()">
            {{ getTrailerStatusLabel() }}
          </span>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="nextAnnualService">NEXT ANNUAL SERVICE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="nextAnnualService"
            name="nextAnnualService"
            type="text"
            class="form-control"
            [inputMask]="dateInputMask"
            placeholder="mm/dd/yyyy"
            [(ngModel)]="trailer.nextAnnualService"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="nextFiveYearService">NEXT 5 YEAR SERVICE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="nextFiveYearService"
            name="nextFiveYearService"
            type="text"
            class="form-control"
            [inputMask]="dateInputMask"
            placeholder="mm/dd/yyyy"
            [(ngModel)]="trailer.nextFiveYearService"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>
    </div>
  </div>
</div>
